import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { getEducationTimeSubscription } from "services";
import { DatePicker, useAccessToken, TimeSubscription } from "modules/common";
import { updateEducationTimeSubscription } from "modules/dashboard";
import { DayModifiers } from "react-day-picker";

export const ProfileEducationTimeSubscription: React.FC = () => {
    const dispatch = useDispatch();
    const accessToken = useAccessToken();
    const [startDate, setStartDate] = useState<Date | null>(null);
    const [endDate, setEndDate] = useState<Date | null>(null);
    const [isEnabled, setIsEnabled] = useState(false);

    useEffect(() => {
        const fetchEducationTime = async () => {
            const result = await getEducationTimeSubscription(accessToken ?? "");
            if (result) {
                setStartDate(result.startDate ? new Date(result.startDate) : null);
                setEndDate(result.endDate ? new Date(result.endDate) : null);
                setIsEnabled(result.isEnabled ?? false);
            }
        };

        fetchEducationTime();
    }, [accessToken]);

    const handleStartDateClick = (day: Date | null) => {
        setStartDate(day);
    };

    const handleEndDateClick = (day: Date | null) => {
        setEndDate(day);
    };

    const handleSubmit = async () => {
        const timeSubscription: TimeSubscription = {
            startDate,
            endDate,
            isEnabled,
        };

        await dispatch(updateEducationTimeSubscription(timeSubscription));
    };

    return (
        <div className="education-time-component">
            <div className="education-date-container">
                <div className="education-date-item">
                    <label>Datum od:</label>
                    <DatePicker
                        onClick={handleStartDateClick}
                        selectedDay={startDate}
                        value={startDate ?? new Date()}
                        displayMonth={new Date()}
                    />
                </div>
                <div className="education-date-item">
                    <label>Datum do:</label>
                    <DatePicker
                        onClick={handleEndDateClick}
                        selectedDay={endDate}
                        value={endDate ?? new Date(new Date().setMonth(new Date().getMonth() + 3))}
                        displayMonth={startDate ?? new Date()}
                        minDate={startDate ?? new Date()}
                    />
                </div>
            </div>

            <div className="education-subscription-item">
                <span className="education-prompt-text">Predbilježbe aktivirane: </span>
                <input
                    type="checkbox"
                    checked={isEnabled}
                    onChange={e => setIsEnabled(e.target.checked)}
                />
            </div>

            <div className="education-button-container">
                <button className="education-submit-button" onClick={handleSubmit}>
                    Spremi
                </button>
            </div>
        </div>
    );
};
